<template>
  <div class="members-list" :class="{ 'no-members': selectedProjectMembersLoading || selectedProjectMembers.length === 0 }">
    <template v-if="selectedProjectMembersLoading">
      <MDBSpinner size="sm" />
    </template>
    <template v-else>
      <template v-if="selectedProjectMembers.length === 0">
        <div class="empty-employees">
          <img src="@/assets/images/2024/empty-employee.png" alt="empty-employee" />
          <div>
            <p>No Employees Assigned yet.</p>
            <p>Go to “Manage Assignee” to start assigning.</p>
          </div>
        </div>
      </template>
      <template v-else>
        <MDBScrollbar>
          <div class="members-info-container" v-for="(members, index) in selectedProjectMembers" :key="index">
            <div class="members-info">
              <div class="members-name">{{ members.lastName }}, {{ members.firstName }}</div>
              <div class="members-id">{{ members.employeeIdNo }}</div>
              <div class="members-status">{{ members.employmentStatus }}</div>
            </div>
          </div>
        </MDBScrollbar>
      </template>
    </template>
  </div>
</template>
<style lang="scss" scoped>
.members-list {
  font-weight: 400;
  padding-left: 16px;
  overflow-y: auto;

  &.no-members {
    display: grid;
    place-content: center;
  }
  .ps {
    padding-right: 16px;
  }

  .empty-employees {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    text-align: center;

    img {
      width: 40px;
      font-size: 12px;
      line-height: 16px;
    }
    p {
      font-size: 12px;
      line-height: 16px;
      color: $neutral-80;
      margin-bottom: 0;

      & + p {
        margin-top: 16px;
      }
    }
  }

  .members-info {
    padding-block: 8px;
    overflow: hidden;
    white-space: nowrap;
  }
  .members-name {
    font-size: 16px;
    line-height: 24px;
    color: $neutral-800;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .members-id,
  .members-status {
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    color: $neutral-400;
  }
  .members-id {
    text-transform: uppercase;
    letter-spacing: 0.11em;
  }
}
</style>
<script>
import { MDBSpinner, MDBScrollbar } from 'mdb-vue-ui-kit';
import { storeToRefs } from 'pinia';
import { useProjectTaggingStore } from '../../../../stores/projectTagging';

export default {
  name: 'ProjectTaggingViewProjectMembersList',
  components: {
    MDBSpinner,
    MDBScrollbar,
  },
  setup() {
    const projectTaggingStore = useProjectTaggingStore();
    const { selectedProjectMembers, selectedProjectMembersLoading } = storeToRefs(projectTaggingStore);
    return {
      selectedProjectMembersLoading,
      selectedProjectMembers,
    };
  },
};
</script>
